export type SubmissionUiState = {
  hasEditedSinceSubmitStart: boolean;
  isPreparingSubmit: boolean;
  showSuccess: boolean;
  submitError: string | null;
};

export type SubmissionUiAction =
  | { type: "edit" }
  | { type: "failure"; message: string }
  | { type: "finish" }
  | { type: "hide-success" }
  | { type: "reset" }
  | { type: "start" }
  | { type: "success" };

export function createSubmissionUiState(): SubmissionUiState {
  return {
    hasEditedSinceSubmitStart: false,
    isPreparingSubmit: false,
    showSuccess: false,
    submitError: null,
  };
}

export function submissionUiReducer(
  state: SubmissionUiState,
  action: SubmissionUiAction,
): SubmissionUiState {
  switch (action.type) {
    case "edit":
      return {
        ...state,
        hasEditedSinceSubmitStart: state.isPreparingSubmit,
        submitError: null,
      };
    case "failure":
      if (state.hasEditedSinceSubmitStart) return state;
      return { ...state, submitError: action.message };
    case "finish":
      return { ...state, isPreparingSubmit: false };
    case "hide-success":
      return { ...state, showSuccess: false };
    case "reset":
      return createSubmissionUiState();
    case "start":
      return {
        hasEditedSinceSubmitStart: false,
        isPreparingSubmit: true,
        showSuccess: false,
        submitError: null,
      };
    case "success":
      return { ...state, showSuccess: true, submitError: null };
  }
}

export function isSubmissionInProgress(
  state: SubmissionUiState,
  mutationPending: boolean,
): boolean {
  return state.isPreparingSubmit || mutationPending;
}
